import React, { useState, useEffect, useRef } from 'react'
// import { useFormik } from 'formik'
// import * as Yup from 'yup'
import ReportsService from '../../../../../services/reports.service'

import {
  Modal,
  Rte,
  MuiButton,
  MuiTextField,
  MuiCheckbox,
  MuiSelect,
  MuiRadioButton,
} from '../../../../../components'
// import { IconButton } from '@mui/material'
import { IconCheck, IconEdit, IconFalse } from '../../../../../assets/images/icons'
import { rteRemovingStyleFromTable } from '../../../../../util'

import { LoginButton, Title, SubTitle, Wrapper, CheckboxWrapper, DropdownWrapper, ColumnWidthWrapper, EqualWidthWrapper, EqualWidth, EqualWidthText, ErrorWrapper, ContentWrapper, ConfigureTableButtonWrapper, ColumnWidth, ColumnWidthTitle } from './style'
import { Typography } from '@mui/material'

const ConfigureTable = (props) => {
  const { settings, InsightsElementId, data, onSuccess, onClose, title, type } = props
  const [categoryName, setCategoryName] = useState(data?.[0]?.CustomColumnCategoryName)
  const [checkboxData, setCheckboxData] = useState(settings.data)
  const [sortColumn, setSortColumn] = useState('')
  const [sortColumnOrdering, setSortColumnOrdering] = useState(true)
  const [equalWidth, setEqualWidth] = useState(false);
  const [widthError, setWidthError] = useState('');
  const fieldLabels = {
    1: 'First',
    2: 'Second',
    3: 'Third',
    4: 'Four',
    5: 'Five',
    6: 'Six',
    7: 'Seven',
    8: 'Eight',
    9: 'Nine',
    10: 'Ten',
    11: 'Eleven',
    12: 'Twelve',
    13: 'Thirteen',
    14: 'Fourteen',
    15: 'Fifteen',
    16: 'Sixteen',
    17: 'Seventeen',
    18: 'Eighteen',
    19: 'Nineteen',
    20: 'Twenty'
  };
  

  const form = useRef()
  const [loader, setLoader] = useState(false)

  console.log(settings);

  const handleOnEditHeader = () => {
    onClose()
  }

  const isEqualWidthValue = () => (100 / checkboxData.length).toFixed();

  const onSubmit = (e) => {
    e.preventDefault()
    const payload = {
      customTableConfiguration: {
        InsightsElementId: InsightsElementId,
        CustomColumnCategoryName: categoryName,
        CustomColumnConfigurations: checkboxData.map((d) => {
          const _customColumnDefaultSortBy = d.CustomColumnName === sortColumn
          const obj = {
            ...d,
            CustomColumnDefaultSortBy: _customColumnDefaultSortBy,
            CustomColumnDefaultSortOrder: sortColumnOrdering ? 'ASC' : 'DESC',
          }
          return {
            CustomColumnConfiguration: obj,
          }
        }),
      },
    }

    setLoader(true)
    ReportsService.reportSetCustomTableConfigurationApi(payload)
      .then((resp) => {
        setLoader(false)
        onSuccess()
      })
      .catch((error) => {
        setLoader(false)
        const resMessage = error
        console.log('ERROR : ', resMessage)
        // enqueueSnackbar(resMessage, { variant: 'error' })
      })
  }

  const checkboxChangeFunc = (type, obj, value) => {
    const finalData = checkboxData.map((d) => {
      if (d.CustomColumnId === obj.CustomColumnId) {
        if (type === 'sortBy') d.CustomColumnSortBy = value
        if (type === 'filterBy') d.CustomColumnFilterBy = value
      }
      return d
    })
    setCheckboxData(finalData)
  }

  const handleTextChange = (data, id) => {
    data = data.replace(/[^0-9]/g, '');
    
    const newData = checkboxData.map((e) => {
      if (e.CustomColumnId === id) {
        e.CustomColumnPercentSize = data
      }
      return e
    });
 
    const widthSize = newData.reduce(
      (acc, elem) => acc + Number(elem.CustomColumnPercentSize || 0),
      0
    );

    if (data === '') {
      setWidthError('Fields cannot be empty.');
      setLoader(true);
    } else if (widthSize > 100) {
      setWidthError('The total percentage exceeds 100%.');
      setLoader(true);
    } else if (widthSize < 100) {
      setWidthError('The total percentage must equal 100%.');
      setLoader(true);
    } else {
      setWidthError('');
      setLoader(false);
    }    

    setCheckboxData(newData);
  }

  const handleEqualWidth = () => {
    setEqualWidth((prev) => {
      if (!prev) {
        if (checkboxData.length === 0) return true;
        
        const updated = checkboxData.map((item) => ({
          ...item,
          CustomColumnPercentSize: isEqualWidthValue(),
        }));

        setCheckboxData(updated);

        setWidthError('');
        setLoader(false);

      }

      return !prev;
    });
  };

  const handleReset = () => {
    const resetData = checkboxData.map((d , i) => ({
      CustomColumnId: d.CustomColumnId,
      customColumnOrder: d.CustomColumnOrder,
      customColumnFilterBy: false,
      customColumnSortBy: false,
      CustomColumnDefaultSortBy: d.CustomColumnDefaultSortBy,
      customColumnDefaultSortOrder: d.customColumnDefaultSortOrder,
      CustomColumnPercentSize: isEqualWidthValue(),
      CustomColumnName: d.CustomColumnName,
    }));

    const selectedObj = settings.data.filter((f) => f.CustomColumnDefaultSortBy)
    const defaultSortColumn = selectedObj?.[0]
      ? selectedObj[0].CustomColumnName
      : settings.data[0].CustomColumnName
    const defaultSortOrder = selectedObj?.[0]
      ? selectedObj[0].CustomColumnDefaultSortOrder === 'ASC'
      : true

    setSortColumn(defaultSortColumn)
    setSortColumnOrdering(defaultSortOrder)

    setCategoryName('Column');
    setEqualWidth(true);
    setCheckboxData(resetData);
  };

  useEffect(() => {
    const firstValue = settings.data[0]?.CustomColumnPercentSize;
    const allEmptyOrSameWidth = settings.data.every(
      (d) => d.CustomColumnPercentSize === 0 || d.CustomColumnPercentSize === firstValue
    );
    
    if(allEmptyOrSameWidth) {
      
      setCheckboxData(checkboxData.map((d) => ({ ...d, CustomColumnPercentSize: isEqualWidthValue()})));
      setEqualWidth(true);
    }

    const selectedObj = settings.data.filter((f) => f.CustomColumnDefaultSortBy)
    const defaultSortColumn = selectedObj?.[0]
      ? selectedObj[0].CustomColumnName
      : settings.data[0].CustomColumnName
    const defaultSortOrder = selectedObj?.[0]
      ? selectedObj[0].CustomColumnDefaultSortOrder === 'ASC'
      : true

    setSortColumn(defaultSortColumn)
    setSortColumnOrdering(defaultSortOrder)
  }, [])

  return (
    <Modal title='Table Configure' showClose={true} onClose={handleOnEditHeader} styleType="themeV2">
      <Wrapper>
        <form ref={form}>
          <ContentWrapper>

            {/* <Title variant='body1'>Table Configure</Title> */}
            {/* <SubTitle>Column Category Name</SubTitle> */}
            <SubTitle>Category Name</SubTitle>
            <MuiTextField
              // placeholder='ColumnCategoryName'
              // title='Column Category Name'
              name='columnCategoryName'
              onChange={(e) => setCategoryName(e.target.value)}
              type='text'
              value={categoryName}
              variant='outlined'
              styletype='themeV2'
            />

            <CheckboxWrapper>
              <SubTitle>Allow Sort By</SubTitle>
              {checkboxData.map((s, i) => {
                return (
                  <MuiCheckbox
                    key={s.CustomColumnId}
                    label={s.CustomColumnName}
                    checked={s.CustomColumnSortBy}
                    onChange={() => checkboxChangeFunc('sortBy', s, !s.CustomColumnSortBy)}
                    styling='themeV2'
                  />
                )
              })}
            </CheckboxWrapper>

            <DropdownWrapper>
              <SubTitle>Default Sort By</SubTitle>
              <MuiSelect
                name='sortColumn'
                onChange={(e) => setSortColumn(e.target.value)}
                title=''
                compact
                data={checkboxData}
                menuprops={{ style: { maxHeight: '200px', maxWidth: '180px' } }}
                placeholder='Select'
                variant={true ? 'outlined' : 'standard'}
                selectlabel='CustomColumnName'
                selectvalue='CustomColumnName'
                value={sortColumn || null}
              />

              <MuiRadioButton
                checked={sortColumnOrdering}
                onChange={(e) => setSortColumnOrdering(true)}
                name='sortColumn'
                title={'Ascending'}
                styling='themeV2'
              />
              <MuiRadioButton
                checked={!sortColumnOrdering}
                onChange={(e) => setSortColumnOrdering(false)}
                name='sortColumn'
                title={'Descending'}
                styling='themeV2'
              />
            </DropdownWrapper>

            <CheckboxWrapper>
              <SubTitle>Filter By</SubTitle>
              {checkboxData.map((s, i) => {
                return (
                  <MuiCheckbox
                    key={s.CustomColumnId}
                    label={s.CustomColumnName}
                    checked={s.CustomColumnFilterBy}
                    onChange={() => checkboxChangeFunc('filterBy', s, !s.CustomColumnFilterBy)}
                    styling='themeV2'
                  />
                )
              })}
            </CheckboxWrapper>


            <SubTitle>Column Width (in %)</SubTitle>
            <ColumnWidthWrapper>
              {checkboxData.map((s, i) => {
                return (
                  <ColumnWidth key={s.CustomColumnId} >
                    <ColumnWidthTitle>{fieldLabels[i + 1]} <span className='required'>*</span></ColumnWidthTitle>
                    <MuiTextField
                      dataType='number'
                      value={s.CustomColumnPercentSize}
                      // title={`${fieldLabels[i + 1]}*`}
                      name={s.CustomColumnName}
                      onChange={(e) => handleTextChange(e.target.value, s.CustomColumnId)}
                      type='text'
                      variant='outlined'
                      styletype='themeV2'
                      disabled={equalWidth}
                      />
                    </ColumnWidth>
                )
              })}
            </ColumnWidthWrapper>
            <ErrorWrapper>{widthError}</ErrorWrapper>

            <EqualWidthWrapper>
              <EqualWidth onClick={handleEqualWidth}>{equalWidth ? <IconCheck /> : <IconFalse />}</EqualWidth>
              <EqualWidthText>Set Equal Width</EqualWidthText>
            </EqualWidthWrapper>

          </ContentWrapper>

          <ConfigureTableButtonWrapper>
            <MuiButton
              onClick={handleReset}
              variant='contained'
              color='gray'
              label='Clear'
            />

            <MuiButton
              color='primary'
              variant='contained'
              type='submit'
              onClick={onSubmit}
              disabled={loader || false}
              label='Apply'
            />
          </ConfigureTableButtonWrapper>
        </form>
      </Wrapper>
    </Modal>
  )
}

export default ConfigureTable
